import { SUPPORT_PHONE, SUPPORT_PHONE_TEL } from '../constants/site';

export default function CallButton({
  className = 't7-btn t7-btn--green',
  label,
  showNumber = true,
}) {
  return (
    <a className={className} href={`tel:${SUPPORT_PHONE_TEL}`}>
      {label || (showNumber ? `Call ${SUPPORT_PHONE}` : 'Call Now')}
    </a>
  );
}
